// extracted by mini-css-extract-plugin
export default {"contents":"FF-z","sectionHeading":"GF-z"};